/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieVideoGridItemViewModelPaginatedResponse } from "../types/SerieVideoGridItemViewModelPaginatedResponse.ts";
import { serieVideoGridItemViewModelSchema } from "./serieVideoGridItemViewModelSchema.ts";

export const serieVideoGridItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => serieVideoGridItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<SerieVideoGridItemViewModelPaginatedResponse>;
